/**
 * Retourne les notifications pour un utilisateur donné.
 *
 * @returns {object[]}
 */
export async function getUserNotifications () {
  // TODO you should implement this using your API
  return new Promise(resolve => {
    window.setTimeout(function () {
      return resolve([
        { id: 'd', message: 'Ma dernière notification' },
        { id: 'c', message: 'Ma troisième notification' },
        { id: 'b', message: 'Ma deuxième notification' },
        { id: 'a', message: 'Ma première notification' }
      ])
    }, Math.random() * 1000 + 250)
  })
}
